export default __webpack_public_path__ + "static/media/web_screen_chat_ptBR.fc63d0e2.png";